module.exports = __webpack_public_path__ + "img/company-c.210cfec.svg";